import { useNode } from "@craftjs/core";
import { ArrowBigDownDash } from "lucide-react";

export default function Placeholder({ children, content, size = 'h-32' }) {
  children = children && <PlaceholderContent>{children}</PlaceholderContent>

  return <div className="p-1 w-full flex items-center justify-center">
    <div className={`flex items-center justify-center ${size} w-[99%] outline-2 outline-dashed outline-blue-300 bg-blue-50/50 rounded-lg transition-all duration-200 hover:outline-blue-400 hover:bg-blue-100/50 group`}>
      <div className="flex flex-col items-center justify-center space-y-2 text-blue-500 group-hover:text-blue-600">
        {children || content}
      </div>
    </div>
  </div>
}

function PlaceholderContent({ children }) {
  return <>
    <div className="w-8 h-8 outline-2 outline-dashed outline-current rounded-full flex items-center justify-center opacity-50">
      <ArrowBigDownDash size={20} />
    </div>
    {children}
    <span className="text-xs opacity-70">Drag a component to this area</span>
  </>
}

export function DroppablePlaceholder({ children }) {
  /**
   * o outer (connect(drag(ref))) especifica que o elemento poderá ser arrastavel ou (ele mesmo ou um descendente dele) poderá ser dropavel
   * o inner (connect(ref)) especifica qual elemento será dropavel, se não for definido, então o elemento pai será dropavel
   * se os dois forem usados no mesmo componente, então a ordem da chamada do hook useNode é importante, pois o outer deve ser chamado primeiro, para que o elemento seja arrastavel, e o inner deve ser chamado depois, para que o elemento seja dropavel
   * se ambos forem usados em componentes diferentes, só tem que ser garantido que o componente que chama o outer seja o pai do componente que chama o inner
   */
  const { connectors: outer } = useNode();
  const { connectors: inner } = useNode();

  return <div ref={ref => outer.connect(ref)} className="m-1 w-full">
    <Placeholder>
      <div ref={inner.drag} className="w-[100%]"></div>
      {children}
    </Placeholder>
  </div>
}
